import { HooksService } from '@shoppykey/hook';
import BaseApp from './BaseApp';

export const apps: (new () => BaseApp)[] = [];

export function registerApps(hooksService: HooksService) {
  apps.forEach((App) => {
    hooksService.registerHookActions(new App());
  });
}
